import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OfflineFacade, UserDetailsFacade } from '@shared/state/facades';
import { combineLatest, mergeMap, Observable, of, take } from 'rxjs';
import cloneDeep from 'lodash.clonedeep';

@UntilDestroy()
@Injectable()
export class DprHseOfflineService {
  constructor(
    private userDetailsFacade: UserDetailsFacade,
    private offlineFacade: OfflineFacade
  ) {}

  updateDependentHsePrevValues(startDate: Date): Observable<boolean> {
    return combineLatest([
      this.userDetailsFacade.query.projectSetup$,
      this.offlineFacade.query.combinedDprDetailsList$,
    ]).pipe(
      untilDestroyed(this),
      take(1),
      mergeMap(([projectSetup, dprDetailsList]) => {
        const hseList = projectSetup?.hseList ?? [];
        const dprDetailsCopy = cloneDeep(dprDetailsList);
        hseList.forEach((hse) => {
          const items = dprDetailsCopy
            .filter((x) => new Date(x.dprDateTime) >= new Date(startDate))
            .sort((a, b) => {
              return (
                new Date(a.dprDateTime).valueOf() -
                new Date(b.dprDateTime).valueOf()
              );
            });

          for (let i = 1; i < items.length; i++) {
            const prevItem = (items[i - 1].dprHSE.dprhseDetails || []).find(
              (x) => x.hseId === hse.id
            );
            const currentItem = (items[i].dprHSE.dprhseDetails || []).find(
              (x) => x.hseId === hse.id
            );

            if (prevItem && currentItem) {
              const prev = prevItem.previous ? prevItem.previous : 0;
              const today = prevItem.today ? prevItem.today : 0;
              currentItem.previous = Number((prev + today).toFixed(2));

              this.offlineFacade.setDprDetails(cloneDeep(items[i]));
            }
          }
        });
        return of(true);
      })
    );
  }
}
